
import { ScriptRequests } from '../../../libs/ScriptRequest'

const PROGRESS_REFRESH_RATE = 1e3;
class FileTransferRequests {
  constructor({
    sendFileParams, progressLoadedParams, actionUrl, onStartLoading, onEndLoading, onSetLoadStatus, onError,
  }) {
    this.state = {
      progressErrorCounter: 0,
    };

    this.params = {
      sendFileParams,
      progressLoadedParams: {
        fileUploadProgress: {
          accountNameOrHash: progressLoadedParams.chash,
          fileTransferSessionId: progressLoadedParams.fileTransferSessionId,
          fileTransferId: progressLoadedParams.fileTransferId,
        },
      },
      sendFileActionUrl: actionUrl,
      progressLoadedActionUrl: `${progressLoadedParams.cmdUrl}/file-transfer/progress-rest/`,
    };

    this.xhrSendFile = new XMLHttpRequest();
    this.progressRequest = new ScriptRequests();
    this.requestInterval = null;

    this.onStartLoading = onStartLoading;
    this.onEndLoading = onEndLoading;
    this.onSetLoadStatus = onSetLoadStatus;
    this.onError = onError;

    this.handleSendFile();
  }

  continueProgressInNewComponent = ({
    onStartLoading = () => {}, onEndLoading = () => {}, onSetLoadStatus = () => {}, onError = () => {},
  }) => {
    this.onStartLoading = onStartLoading;
    this.onEndLoading = onEndLoading;
    this.onSetLoadStatus = onSetLoadStatus;
    this.onError = onError;
  }

  unsubscribe() {
    this.onStartLoading = () => {};
    this.onEndLoading = () => {};
    this.onSetLoadStatus = () => {};
  }

  abort = () => {
    this.xhrSendFile.abort();
    this.progressRequest.abort();
    clearInterval(this.requestInterval);
  }

  handleSendFile = () => {
    this.xhrSendFile.onloadstart = this.onStartLoading;
    this.xhrSendFile.open('POST', this.params.sendFileActionUrl, true);
    this.xhrSendFile.send(this.params.sendFileParams);

    this.handleProgressLoadedChecking();
  }

  handleProgressLoadedChecking = () => {
    const progressLoadedRequest = () => {
      const onProgressError = () => {
        this.state.progressErrorCounter++;
        if (this.state.progressErrorCounter > 10) {
          this.onEndLoading(false);
          clearInterval(this.requestInterval);
        }
      };
      const onProgressLoad = result => {
        if (result.state === 'active') {
          const total = this.handleFormatBiteToMB(+result.size.replace(/,/g, ''));
          const uploadedMB = this.handleFormatBiteToMB(+result.uploaded.replace(/,/g, '')).toFixed(2);
          this.onSetLoadStatus(total, uploadedMB);
        } else if (result.state === 'blocked') {
          this.onEndLoading(false);
          clearInterval(this.requestInterval);
        } else if (result.state === 'ended') {
          this.onEndLoading(true);
          clearInterval(this.requestInterval);
        } else { /* state === 'error' */
          onProgressError();
        }
      };

      this.progressRequest.send({
        url: this.params.progressLoadedActionUrl,
        params: { params: JSON.stringify(this.params.progressLoadedParams) },
        onSuccess: onProgressLoad,
        onError: onProgressError,
      });
    };

    // setTimeout(() => {
    this.requestInterval = setInterval(progressLoadedRequest, PROGRESS_REFRESH_RATE);
    // }, 2000);
  }

  handleFormatBiteToMB = bites => +(bites / 1024 / 1024).toFixed(2)
}

export default FileTransferRequests;
